import { openBlobFile } from "@/utils/utils";
import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { pointsReportApi } from "../../../modules/commissions/points/api";
import {
  PointsReportFilterExportRequest,
  PointsReportFilterPageRequest,
} from "../../../modules/commissions/points/types";

export const POINTS_REPORT_QUERY_KEYS = {
  filterPointsReport: (payload: PointsReportFilterPageRequest) => ["filterPointsReport", payload],
  downloadPointsReportExport: () => ["downloadPointsReportExport"],
};

export const useFilterPointsReport = (payload: PointsReportFilterPageRequest) => {
  return useQuery({
    queryKey: POINTS_REPORT_QUERY_KEYS.filterPointsReport(payload),
    queryFn: async () => {
      const { data } = await pointsReportApi.filterPointsReport(payload);

      return data;
    },
    placeholderData: keepPreviousData,
  });
};

export const useDownloadPointsReportExport = () => {
  return useMutation({
    mutationKey: POINTS_REPORT_QUERY_KEYS.downloadPointsReportExport(),
    mutationFn: async (payload: PointsReportFilterExportRequest) => {
      const response = await pointsReportApi.downloadPointsReportExport(payload);
      openBlobFile(response, true);

      return response.data;
    },
  });
};
